///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.create = abcsetup.atp_documents.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents.create = {

    init: function() {
        $(document).on('change keyup', '#app_models_a_t_p_document__org_id', function(e) {
            let org_id = $(this).val();

            if (org_id == undefined || org_id == null || org_id == '') {
                return;
            }

            abcsetup.blockUI(true);
            $('#submit-button').prop('disabled', true);

            axios.get('/api/atp_documents/'+org_id+'/vendor_contacts')
                .then(response => {
                    const contacts = response.data.contacts;

                    let container = $('#vendor-contacts-list');
                    container.children().remove(); /* Clear existing list of Supplier Contacts */

                    if (response.data.success && contacts.length) {
                        $('#vendor-contact').html('<span class="text-bold text-green"><i class="fas fa-check"></i> Vendor Contact(s) Found</span>');
                        $('#submit-button').prop('disabled', false);

                        container.append(`
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>User</th>
                                        <th>Email</th>
                                        <th>Vendor</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>
                                <tbody class="supplier-list-tbody">
                        `)

                        contacts.forEach(element => {
                            $('.supplier-list-tbody').append(`
                                <tr>
                                    <td>${element.name}</td>
                                    <td>${element.email_address}</td>
                                    <td>${element.vendor_name}</td>
                                    <td>${element.type}</td>
                                </tr>
                            `);
                        });

                        container.append('</tbody></table>');

                    } else {
                        $('#vendor-contact').html('<span class="text-bold text-red"><i class="fas fa-times"></i> Vendor Contact Not Found</span>');
                        $('#submit-button').prop('disabled', true);
                    }

                    abcsetup.unblockUI();
                })
                .catch(error => {
                    console.error(error);
                });
        });
    },

}
